import Defer from "../services/defer";
import { getTranslateNsT } from "./get-translate-nst";
const t = getTranslateNsT("overview");

function uint8array2buf(arr: Uint8Array): Buffer {
  return new Buffer(arr);
}
function buf2uint8array(buf: Buffer): Uint8Array {
  return new Uint8Array(buf);
}
function readBlobData(blob: Blob): Promise<string> {
  const defer = new Defer<string>();
  const data = blob.slice(0, blob.size);
  const reader = new FileReader();
  reader.readAsText(data);
  reader.onload = (event: Event) => {
    defer.resolve(reader.result as string);
  };
  return defer.promise;
}
function speedUnitConversion(num = 0, fix = 2): string {
  /**
   * 1024 => KB
   * 1024 * 1024 = 1048576 => MB
   * 1024 * 1024 * 1024 = 1073741824 => GB
   * 1024 * 1024 * 1024 * 1024 = 1099511627776 => TB
   */
  switch (true) {
    case num <= 0:
      return "0 KB/s";
    case num < 1048576:
      return `${(num / 1024).toFixed(fix)} KB/s`;
    case num < 1073741824:
      return `${(num / 1048576).toFixed(fix)} MB/s`;
    case num < 1099511627776:
      return `${(num / 1073741824).toFixed(fix)} GB/s`;
    default:
      return `${(num / 1099511627776).toFixed(fix)} TB/s`;
  }
}
function unitConversion(num = 0, fix = 2): string {
  switch (true) {
    case num <= 0:
      return "--";
    case num < 1024:
      return `${num} B`;
    case num < 1048576:
      return `${(num / 1024).toFixed(fix)} KB`;
    case num < 1073741824:
      return `${(num / 1048576).toFixed(fix)} MB`;
    case num < 1099511627776:
      return `${(num / 1073741824).toFixed(fix)} GB`;
    default:
      return `${(num / 1099511627776).toFixed(fix)} TB`;
  }
}
function bitConversion(num = 0, unit = "k", fix = 2): number {
  /**
   * 1024 => Kbps
   * 1024 * 1024 = 1048576 => Mbps
   * 1024 * 1024 * 1024 = 1073741824 => Gbps
   * 1024 * 1024 * 1024 * 1024 = 1099511627776 => Tbps
   */
  switch (true) {
    case num <= 0:
      return 0;
    case unit.toLowerCase() === "k":
      return Number((num / 1024).toFixed(fix));
    case unit.toLowerCase() === "m":
      return Number((num / 1048576).toFixed(fix));
    case unit.toLowerCase() === "g":
      return Number((num / 1073741824).toFixed(fix));
    case unit.toLowerCase() === "t":
      return Number((num / 1099511627776).toFixed(fix));
    default:
      return 0;
  }
}
function statusConversion(status: number): string | undefined {
  /**
   * NONE                   = 0;
   * INCORRECT_PASSWORD     = 1;
   * TIMEOUT                = 2;
   * DISCONNECTING          = 3;
   * DISCONNECTED           = 4;
   * CONNECTING             = 5;
   * CONNECTION_FAILED      = 6;
   * INTERRUPTED            = 7;
   * WAIT_BROWSING          = 8;
   * WAIT_PASSWORD          = 9;
   * LOCAL_FILE_UNWRITEABLE = 10;
   * COULD_NOT_START        = 11;
   * TRANSFERRING           = 12;
   * CREATING_DIR           = 13;
   * FILE_NOT_EXIST         = 14;
   * SERVER_DISK_NOSPACE    = 15;
   * CLIENT_DISK_NOSPACE    = 16;
   * DOWNLOAD_REPETITION    = 17;
   */
  return {
    0: t("tansfer_default_waiting"),
    1: t("tansfer_default_INCORRECT_PASSWORD"),
    2: t("tansfer_default_timeout"),
    3: t("tansfer_default_DISCONNECTING"),
    4: t("tansfer_default_DISCONNECTED"),
    5: t("tansfer_default_CONNECTING"),
    6: t("tansfer_default_CONNECTION_FAILED"),
    7: t("tansfer_default_paused"),
    10: t("tansfer_default_LOCAL_FILE_UNWRITEABLE"),
    11: t("tansfer_default_COULD_NOT_START"),
    13: t("tansfer_default_CREATING_DIR"),
    14: t("tansfer_default_FILE_NOT_EXIST"),
    15: t("tansfer_default_SERVER_DISK_NOSPACE"),
    16: t("tansfer_default_CLIENT_DISK_NOSPACE"),
    17: t("tansfer_default_DOWNLOAD_REPETITION"),
  }[status];
}

/**
 * @description return true if version x > version y
 */
function versionCompare(x: string, y: string): boolean {
  const xL = x.split(".");
  const yL = y.split(".");
  let ret: boolean = false;
  for (let i: number = 0; i < xL.length; i++) {
    if (Number(xL[i]) > Number(yL[i])) {
      ret = true;
      break;
    }
  }
  return ret;
}

export {
  uint8array2buf,
  buf2uint8array,
  readBlobData,
  speedUnitConversion,
  unitConversion,
  bitConversion,
  statusConversion,
  versionCompare,
};
